import HeaderBar from "components/HeaderBar";
import Loading from "components/Loading";
import Page from "components/Page";
import { useState } from "react";
import { certGETj } from "lib/API";
import Input from "components/Input";
import { ButtonPrimary } from "components/Buttons";

const nr = (t) =>
  ["N/R", "n/r", "Not Recorded", "Not recorded", "not recorded"].includes(t)
    ? "-"
    : t;

export default function SearchVIN() {
  const [searchArray, setSearchArray] = useState([""]);
  function handleSet(k, v) {
    setSearchArray((sa) => sa.map((sam, sami) => (sami === k ? v : sam)));
  }
  const s = searchArray.map((sa) => sa.trim()).join("");
  const disabled = !s;

  const [results, setResults] = useState(null);
  const [loading, setLoading] = useState(false);

  const [sort, setSort] = useState({ key: "mm", reverse: false });
  let sortedResults = [...results]?.sort((a, b) =>
    a[sort.key]
      ?.replace(/[^A-Za-z0-9]*/, "")
      ?.localeCompare(b[sort.key]?.replace(/[^A-Za-z0-9]*/, "")),
  );
  if (sort.reverse) sortedResults = sortedResults?.reverse();

  async function doSearch() {
    setLoading(true);
    const r = await certGETj(
      `searchVIN?${searchArray.map((s) => `search=${encodeURIComponent(s)}`).join("&")}`,
    );
    if (r.success) {
      setResults(r.data);
      setLoading(false);
    }
  }

  const sa = (key) =>
    sort.key === key ? (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth="1.5"
        stroke="currentColor"
        className={`inline text-blue-500 size-6 cursor-pointer transition-transform ${sort.reverse ? "rotate-180" : "rotate-0"}`}
        onClick={() => setSort((s) => ({ key, reverse: !s.reverse }))}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M4.5 10.5 12 3m0 0 7.5 7.5M12 3v18"
        />
      </svg>
    ) : (
      <span
        className="text-blue-500 underline mx-1 cursor-pointer"
        onClick={() => setSort({ key, reverse: false })}
      >
        sort
      </span>
    );

  return (
    <Page title="Search VIN">
      {loading ? (
        <Loading />
      ) : (
        <>
          <HeaderBar>
            {searchArray.map((sa, sai) => (
              <Input
                key={sai}
                value={sa}
                setValue={(v) => handleSet(sai, v)}
                label={`Search`}
                onEnter={doSearch}
              />
            ))}
            <div className="btn-group mt-4">
              <ButtonPrimary onClick={doSearch} disabled={disabled}>
                Search &gt;&gt;
              </ButtonPrimary>
            </div>
          </HeaderBar>
          <div className="py-2 px-4">
            {sortedResults?.length === 0 && <p>No results</p>}
            {sortedResults?.length > 0 && (
              <table>
                <thead>
                  <tr>
                    <th>
                      {sa("vin")}
                      VIN
                    </th>
                    <th>
                      {sa("mm")}
                      Make Model
                    </th>
                    <th>
                      {sa("engineNumber")}
                      Engine
                    </th>
                    <th>
                      {sa("bodyNumber")}
                      Body
                    </th>
                    <th>
                      {sa("certNumber")}
                      Cert Number
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {sortedResults.map((r) => (
                    <tr key={`${r.vin}`}>
                      <td className="border-r pr-2 text-right">{r.vin}</td>
                      <td className="border-l pl-2 text-left">{r.mm}</td>
                      <td className="border-l pl-2 text-left">
                        {nr(r.engineNumber)}
                      </td>
                      <td className="border-l pl-2 text-left">
                        {nr(r.bodyNumber)}
                      </td>
                      <td className="border-l pl-2 text-left">
                        <a
                          className="underline text-blue-700"
                          href={`/search1?q=${btoa(r.certNumber)}#${btoa(r.certNumber)}`}
                        >
                          {r.certNumber}
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </>
      )}
    </Page>
  );
}
